import { IconSVG } from '../types';

export const Medal = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path d="M12 20.702l-2.923.99a1.827 1.827 0 01-.577.09 1.79 1.79 0 01-1.265-.509c-.362-.34-.543-.772-.543-1.298V14.91L3.94 10.454a1.824 1.824 0 010-1.908l3.207-5.192c.164-.275.382-.485.653-.633a1.82 1.82 0 01.884-.221h6.634c.318 0 .613.074.884.221.271.148.489.358.653.633l3.208 5.192a1.824 1.824 0 010 1.908l-2.754 4.456v5.065c0 .526-.181.958-.543 1.298a1.79 1.79 0 01-1.265.51 1.826 1.826 0 01-.577-.09L12 20.701zm0-1.59l3.404 1.132c.103.032.196.02.279-.038a.286.286 0 00.125-.25V16.5H8.192v3.456c0 .109.042.192.125.25.084.058.177.07.28.038L12 19.111zM8.683 15h6.634c.052 0 .1-.013.145-.039a.362.362 0 00.115-.105l3.217-5.193a.304.304 0 000-.327l-3.217-5.192a.363.363 0 00-.115-.106.286.286 0 00-.145-.038H8.683c-.051 0-.1.013-.144.038a.361.361 0 00-.116.106L5.206 9.336a.303.303 0 000 .327l3.217 5.193a.36.36 0 00.116.105.285.285 0 00.144.039zm2.267-3.894l3.708-3.733a.65.65 0 01.514-.215.781.781 0 01.53.215.724.724 0 01.236.535.72.72 0 01-.22.534l-4.135 4.144a.867.867 0 01-.633.272.867.867 0 01-.632-.272l-2.02-2.01a.71.71 0 01-.232-.529.74.74 0 01.232-.54.735.735 0 01.535-.232c.201 0 .38.078.534.233l1.583 1.598z" />
    </svg>
  );
};
